










































import { Component, Prop, Vue, Inject, Watch } from 'vue-property-decorator';
import { Anagrafica } from '../models/anagrafica.model';
import { Page } from '../models/page.model';

@Component({})
export default class AnagraficaTable extends Vue {

  @Prop() data!: Anagrafica[];
  @Prop() page!: Page;
  @Prop() loading!: boolean;

  firstload: boolean = true;

  @Watch('data')
  onDataChange() {
    this.firstload = false;
  }

  onPageChange(page: number) {
    this.$emit('page', page);
  }
}
